<template>
  <div class="show__wrapper">
    <span v-if="label" class="show__heading-label">{{ label }}</span>
    <div class="show__heading">
      <div @click="$router.back()" class="show__back">
        <v-icon>mdi-chevron-left</v-icon>
      </div>
      <h1>{{ title }}</h1>
      <div class="ml-auto d-flex pl-4">
        <slot name="actions"> </slot>
      </div>
    </div>
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: "ResourceShowWrapper",
    props: {
      title: {
        type: String,
        default: "",
      },
      label: {
        type: String,
        default: "",
      },
    },
  };
</script>
<style scoped lang="scss">
  @import "../../@core/preset/preset/typography/index.scss";
  @import "../../@core/preset/preset/functions";

  .show {
    &__wrapper {
      .show__back {
        margin-right: 15px;

        .v-icon {
          color: get-color("primary");
          height: 30px;
          width: 10px;
          font-size: 32px;
          cursor: pointer;
        }
      }
      .show__heading {
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        h1 {
          @include heading-2();
          color: get-color("headline");
        }
        &-label {
          @include text-subtitle-1();
          color: get-color("subtitle");
          margin-left: 25px;
        }
      }
    }
  }
</style>
